import styled from 'styled-components';
import palette from '../../lib/styles/palette';

import PowerCalculationJIS from './editor-components/PowerCalculationJIS';
import DriveSelectionForm from './editor-components/DriveSelectionForm';
import BeltForm from './editor-components/BeltForm';
// import PulleyFormDrive from './editor-components/PulleyFormDrive';
// import DrivePulleyDiaForm from './editor-components/DrivePulleyDiaForm';
import ProfileForm from './editor-components/ProfileForm';
// import CopyFromOhtersButton from './editor-components/CopyFromOhtersButton';
import ConveyorTypeSelectionRadioButtons from './ConveryorTypeSelectionRadioButtons';
import DrivePulleySelectionForm from './editor-components/DrivePulleySelectionForm';
import DriveComponentSelectionForm from './editor-components/DriveComponentSelectionForm';

import { useSelector } from 'react-redux';
// import PipeConveyorPowerCalculationNewJIS from './editor-components/PipeConveyorPowerCalculationNewJIS';
import PipeConveyorPowerCalculationOldJIS from './editor-components/PipeConveyorPowerCalculationOldJIS';
// import HorizontalCurveResistance from './editor-components/HorizontalCurveResistance';
import React, { /*useEffect, useState*/ } from 'react';
import ApplyCodeSelectionRadioButtons from './ApplyCodeSelectionRadioButtons';
import ReturnPipeConveyorPowerCalculationOldJIS from './editor-components/ReturnPipeConveyorPowerCalculationOldJIS';
// import HorizontalCurveResistanceOldJIS from './editor-components/HorizontalCurveResistanceOldJIS';
// import TestForm from './editor-components/TestForm';
// import PowerCalculationJISNew from './editor-components/PowerCalculationJISNew';

const ConveyorEditorBlock = styled.div`
    width: 100%;
    max-width: 1280px;
    min-width: 800px;
    margin: 0 auto;
    // background-color: yellow;
    input::placeholder {
        color: ${palette.lime[4]};
    }
`;

const ConveyorHead = styled.div`
    width: 100%;
    // border-bottom: 1px solid ${palette.gray[2]};
    padding: 0 1rem 2rem;
    margin-bottom: 3rem;
    h3 {
        font-size: 1.25rem;
        // 기본 높이가 높기때문에 위아래 마진을 줄이기 위해
        line-height: 1.5;
        margin: 0;
    }
`;

const TitleInput = styled.input`
    font-size: 1rem;
    outline: none;
    padding-bottom: 0.5rem;
    border: none;
    border-bottom: 1px solid ${palette.gray[4]};
    margin-bottom: 0.5rem;
    width: 250px;
`;

// const ProjectInfo = styled.div`
//     color: ${palette.cyan[6]};
//     &:hover {
//         color: ${palette.cyan[4]};
//         cursor: pointer;
//     }
// `;

const ConveyorEditor = ({ onChangeField, title, conveyorType, applyCode, lineQty, body, project, isValidTension }) => {
    const language = useSelector((state) => state.language.language);
    const isKR = language === 'KR' ? true : false;
    const isJP = language === 'JP' ? true : false;
    const isEN = language === 'EN' ? true : false;

    const onChangeTitle = (e) => {
        onChangeField({ key: 'title', value: e.target.value });
    };

    const onChangeLineQty = (e) => {
        onChangeField({ key: 'lineQty', value: e.target.value });
    };

    const {
        profile,
        input,
        output,
        resistance,
        drives,
        belt,
        // drivePulley,
        pulleys,
        fluidCouplings,
        gearCouplings,
        reducers,
        brakes,
        backstops,
    } = body;

    // const [maxCarryTension, setMaxCarryTension] = useState({
    //     load: 0,
    //     noLoad: 0,
    // });
    // const [minReturnTension, setMinReturnTesnion] = useState({
    //     load: 0,
    //     noLoad: 0,
    // });

    // const horizontalCurve = useSelector((state) => state.conveyorWrite.body.horizontalCurve);

    // const [horizontalCarryResistance, setHorizontalCarryResistance] = useState({
    //     load: horizontalCurve?.carryResistance?.load || 0,
    //     noLoad: horizontalCurve?.carryResistance?.noLoad || 0,
    // });
    // const [horizontalReturnResistance, setHorizontalReturnResistance] = useState({
    //     load: horizontalCurve?.carryResistance?.load || 0,
    //     noLoad: horizontalCurve?.carryResistance?.noLoad || 0,
    // });



    const isValidCalculation = (conveyorType === 'Troughed' && applyCode === 'JIS B-8805(New)') || ((conveyorType === 'Pipe' || 'Return Pipe') && applyCode === 'JIS B-8805(Old)')


    return (
        <ConveyorEditorBlock>
            <ConveyorHead>
                <TitleInput
                    placeholder={
                        isKR
                            ? '컨베이어 이름을 입력하세요'
                            : isJP
                            ? 'コンベヤの名前を入力してください'
                            : isEN
                            ? 'Input Conveyor Number'
                            : ''
                    }
                    onChange={onChangeTitle}
                    value={title}
                />
                {/* <ProjectInfo>
                    <span>
                        <b>Project: {project?.title}</b>
                    </span>
                </ProjectInfo> */}
                <LineQtyInput
                    placeholder={isKR ? '수량' : isJP ? '数量' : isEN ? 'Qty' : ''}
                    onChange={onChangeLineQty}
                    value={lineQty}
                />
                line(s)
                <ConveyorTypeSelectionRadioButtons conveyorType={conveyorType} />
                <ApplyCodeSelectionRadioButtons conveyorType={conveyorType} applyCode={applyCode} />
                {/* {conveyorType === 'Pipe' && <ApplyCodeSelectionRadioButtons applyCode={applyCode} />} */}
            </ConveyorHead>
            {/* { */}
            {/* (!conveyorType || conveyorType === 'Troughed') && <> */}
            <Spacer />
            <hr />
            <Spacer />
            {isValidCalculation && (
                <>
                    <ProfileForm profile={profile} />
                    <Spacer />
                    <hr />
                </>
            )}
            {/* <ProfileForm profile={profile} /> */}
            {/* <PowerCalculationJISNew /> */}
            {conveyorType === 'Troughed' && applyCode === 'JIS B-8805(New)' && (
                <PowerCalculationJIS />
            )}
            {conveyorType === 'Troughed' && !(applyCode === 'JIS B-8805(New)') && (
                <div style={{ textAlign: 'center', fontSize: '1.5rem' }}>⚠️ Under Construction</div>
            )}
            {conveyorType === 'Pipe' && applyCode === 'JIS B-8805(New)' && (
                // <PipeConveyorPowerCalculationNewJIS
                //     horizontalCarryResistance={horizontalCarryResistance}
                //     setHorizontalCarryResistance={setHorizontalCarryResistance}
                //     horizontalReturnResistance={horizontalReturnResistance}
                //     setHorizontalReturnResistance={setHorizontalReturnResistance}
                // />
                <div style={{ textAlign: 'center', fontSize: '1.5rem' }}>⚠️ Under Construction</div>
            )}
            {conveyorType === 'Pipe' && applyCode === 'JIS B-8805(Old)' && (
                <PipeConveyorPowerCalculationOldJIS
                    // horizontalCarryResistance={horizontalCarryResistance}
                    // setHorizontalCarryResistance={setHorizontalCarryResistance}
                    // horizontalReturnResistance={horizontalReturnResistance}
                    // setHorizontalReturnResistance={setHorizontalReturnResistance}
                    isValidTension={isValidTension}
                />
                // <p>Old JIS 계산폼</p>
            )}
            {conveyorType === 'Return Pipe' && applyCode === 'JIS B-8805(Old)' && (
                <ReturnPipeConveyorPowerCalculationOldJIS />
            )}
            {conveyorType === 'Return Pipe' && applyCode === 'JIS B-8805(New)' && (
                <div style={{ textAlign: 'center', fontSize: '1.5rem' }}>⚠️ Under Construction</div>
            )}
            {/* <PowerCalculationJIS /> */}
            <Spacer />
            <hr />
            <DriveSelectionForm drives={drives} resistance={resistance} input={input} output={output} />
            {/* {conveyorType === 'Pipe' && applyCode === 'JIS B-8805(New)' && (
                <HorizontalCurveResistance
                    carrySideTension={maxCarryTension}
                    returnSideTension={minReturnTension}
                    setHorizontalCarryResistance={setHorizontalCarryResistance}
                    setHorizontalReturnResistance={setHorizontalReturnResistance}
                />
            )} */}
            {/* {conveyorType === 'Pipe' && applyCode === 'JIS B-XXXX(Old)' && (
                <HorizontalCurveResistanceOldJIS
                    carrySideTension={maxCarryTension}
                    returnSideTension={minReturnTension}
                    setHorizontalCarryResistance={setHorizontalCarryResistance}
                    setHorizontalReturnResistance={setHorizontalReturnResistance}
                />
            )} */}
            <Spacer />
            <hr />
            <BeltForm />
            {/* <DrivePulleyDiaForm drivePulley={drivePulley} /> */}
            <Spacer />
            <hr />
            <DrivePulleySelectionForm drives={drives} pulleys={pulleys} belt={belt} />
            <Spacer />
            <hr />
            <DriveComponentSelectionForm
                drives={drives}
                resistance={resistance}
                pulleys={pulleys}
                fluidCouplings={fluidCouplings}
                gearCouplings={gearCouplings}
                reducers={reducers}
                brakes={brakes}
                backstops={backstops}
            />
            {/* </> */}
            {/* } */}
        </ConveyorEditorBlock>
    );
};

export default ConveyorEditor;

const LineQtyInput = styled.input`
    font-size: 1rem;
    outline: none;
    padding-bottom: 0.5rem;
    border: none;
    border-bottom: 1px solid ${palette.gray[4]};
    margin-bottom: 0.5rem;
    width: 50px;

    margin-left: 2rem;
    text-align: right;
    padding-right: 1rem;
`;

const Spacer = styled.div`
    margin: 2rem 0;
`;
